module.exports = __webpack_public_path__ + "static/img/school-diff.a1f148b3.png";